<div *ngIf="emailModalData.windowEnabled">
    <mat-form-field appearance="fill" class="email-input">
      <mat-label>email</mat-label>
      <input matInput placeholder="pat@example.com" [formControl]="email" required (keyup)="onFilledEmail($event)">
      <mat-error *ngIf="email.invalid">{{getErrorMessage()}}</mat-error>
    </mat-form-field>
</div>